/**
 * tdesign v1.11.4
 * (c) 2025 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-6e49aa22.mjs';
import { defineComponent, reactive, h, createApp } from 'vue';
import { merge } from 'lodash-es';
import _Loading from './loading.mjs';
import { getAttach, addClass, removeClass } from '../utils/dom.mjs';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import '../_chunks/dep-6da93342.mjs';
import '../_chunks/dep-8d3c9348.mjs';
import '../_chunks/dep-d531a7f4.mjs';
import './icon/gradient.mjs';
import '../_chunks/dep-b0b0fb5e.mjs';
import '../_chunks/dep-684f6096.mjs';
import '../_chunks/dep-35b16530.mjs';
import '../_chunks/dep-11896cb9.mjs';
import '../_chunks/dep-5112e56c.mjs';
import '../utils/render-tnode.mjs';
import '../hooks/useTeleport.mjs';
import './props.mjs';
import '../_chunks/dep-b0ea6825.mjs';
import '../config-provider/hooks/useConfig.mjs';
import '../config-provider/utils/context.mjs';
import '../_chunks/dep-99da72b8.mjs';
import '../_chunks/dep-2705c570.mjs';
import '../_chunks/dep-bc824998.mjs';
import '../config-provider/type.mjs';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var fullScreenLoadingInstance = null;
function mergeDefaultProps(props) {
  var options = merge({
    fullscreen: false,
    attach: "body",
    loading: true,
    preventScrollThrough: true
  }, props);
  return options;
}
function createLoading(props) {
  var mergedProps = mergeDefaultProps(props);
  if (mergedProps.fullscreen && fullScreenLoadingInstance) {
    return fullScreenLoadingInstance;
  }
  var component = defineComponent({
    setup: function setup() {
      var loadingOptions = reactive(mergedProps);
      return {
        loadingOptions: loadingOptions
      };
    },
    render: function render() {
      return h(_Loading, _objectSpread({}, this.loadingOptions));
    }
  });
  var attach = getAttach(mergedProps.fullscreen ? "body" : mergedProps.attach);
  var app = createApp(component);
  var loading = app.mount(document.createElement("div"));
  var parentRelativeClass = usePrefixClass("loading__parent--relative").value;
  var lockClass = usePrefixClass("loading--lock");
  var lockFullscreen = mergedProps.preventScrollThrough && mergedProps.fullscreen;
  if (lockFullscreen) {
    addClass(document.body, lockClass.value);
  }
  if (attach) {
    addClass(attach, parentRelativeClass);
  } else {
    console.error("attach is not exist");
  }
  var loadingInstance = {
    hide: function hide() {
      loading.loading = false;
      removeClass(attach, parentRelativeClass);
      removeClass(document.body, lockClass.value);
      app.unmount();
    }
  };
  return loadingInstance;
}
function produceLoading(props) {
  if (props === true) {
    fullScreenLoadingInstance = createLoading({
      fullscreen: true,
      loading: true,
      attach: "body",
      preventScrollThrough: true
    });
    return fullScreenLoadingInstance;
  }
  if (props === false) {
    var _fullScreenLoadingIns;
    (_fullScreenLoadingIns = fullScreenLoadingInstance) === null || _fullScreenLoadingIns === void 0 || _fullScreenLoadingIns.hide();
    fullScreenLoadingInstance = null;
    return;
  }
  return createLoading(props);
}
var LoadingPlugin = produceLoading;
LoadingPlugin.install = function (app) {
  app.config.globalProperties.$loading = produceLoading;
};

export { LoadingPlugin, LoadingPlugin as default };
//# sourceMappingURL=plugin.mjs.map
